import { type PropsWithChildren } from 'react';

import { labelStyle } from './Label.sty.js';
import type { ComponentWithName } from '../../../../../../core/types/component-with-name.js';

export const Label = ({ children }: PropsWithChildren) => {
  if (children === undefined) {
    return null;
  }

  return <p className={labelStyle}>{children}</p>;
};

(Label as ComponentWithName<typeof Label>).displayName = 'MeterBarLayout.Label';
